import { pp, pp_user, notify, dateNow, hasRole, downloadFile, findShopIdOfClient, myConfirmDialog /* app_state, pluralize, e, link, formatDate */ } from '@helpers'

import { colisStore } from "@stores";

//? for updateStatus()
// import { Dialog } from 'quasar' / attribué directement � $q   dans quasar.conf.js
import DialogComponentForUpdateStatus from '@page/Course/partials/DialogComponentForUpdateStatus.vue'
import DialogComponentSignature from '@page/Course/partials/DialogComponentSignature.vue'


export const useCourseStore = {

    state: () => ({

        loading: false,
        filter: '',
        filter_min_length: 2,

        table_fullscreen: false,

        columns:[
            // { name: 'id', align: 'center', label: '', field: 'id', visible: false/* , sortable: true  */},
            { name: 'expand', align: 'center', label: '', field: 'expand'/* , sortable: true  */},
            { name: 'created_at', align: 'center', label: 'Dates<br/>Créations', field: 'created_at', sortable: true },
            { name: 'status', align: 'center', label: 'Statut', field: 'status'/* , sortable: true */ },
            { name: 'priority', align: 'center', label: 'Priorité<br/>Livraison', field: 'priority', sortable: true },
            { name: 'ref', align: 'center', label: 'Références', field: 'ref' },
            { name: 'shop_id', align: 'center', label: 'Expéditeurs', field: 'shop_id', sortable: true },
            { name: 'recipient_id', align: 'center', label: 'Destinataires', field: 'recipient_id', sortable: true },
            { name: 'count_colis', align: 'center', label: 'Nombre<br/>Colis', field: 'count_colis' },
            { name: 'carrier_doc', align: 'center', label: 'Lettres de<br/>Voiture', field: 'carrier_doc' },
            // { name: 'driver', align: 'center', label: 'Chauffeur', field: 'driver', sortable: true },
            // { name: 'canceler', align: 'center', label: '', field: 'canceler' },
            { name: 'actions', align: 'center', label: '', field: 'actions'/* , sortable: true  */},
        ],

        pagination: { rowsPerPage: 20/*same in Controller*/, rowsNumber: 20, page: 1, sortBy: 'created_at', descending: true },


        form: {},

        openModalAddColis: {},

        recapMonthlyResult: [],
        // recapMonthlyPeriod: '',
        recapMonthlyOpenModal: false,

        // formAddRecipient: {}, // créer un Destinataire
        // showRecipientAddForm: false,


        selectGroupedDelivery: [],

    }),

    getters: {


        waiting(){ // En Attente
            return (status)=> status.skey == 'waiting'
        },
        accepted(){ // Acceptée par le transporteur
            return (status)=> status.pos >= this.getStatusPos('accepted')
        },
        refused(){ // refusée par le transporteur
            return (status)=> status.skey == 'refused'
        },
        supported(){ // prise en charge
            return (status)=> status.pos >= this.getStatusPos('supported')
        },
        delivered(){ // livré
            return (status)=> status.skey == 'delivered'
        },
        nobody(){ // personne au rdv
            return (status)=> status.skey == 'nobody'
        },
        denied(){ // refusée par le destinataire
            return (status)=> status.skey == 'denied'
        },
        notDelivered(){ // pris en charge  ET  non livré
            return (status)=> status.skey != 'delivered'
        },

        stocked()
        {
            return (status)=> status.skey == 'stocked'
        },

	    not_available(){
            return (status) => status.skey == 'unavailable'
        },

        notDeliveredAndNotStocked()
        {   
            return (status) => (status.skey != 'stocked') && (status.skey != 'delivered')
        },

        isValidable(){

            return (course) => {
                return Boolean(course?.shop_id && course?.client_id && course?.recipient_id && _.size(course.colis))
            }
        },

        courseIsDisabledEdit(){
	    
            return (course) => {
		if (this.not_available(course?.status_current))
                {
                    return false;
                }
                // return Boolean((Number(course?.status) >= 1 && course?.validated_at) || course?.signed || course?.deleted_at || (/* hasRole(pp().user?.roles, 'client') */pp().isClient && course?.creator_id != pp().user.id))
                // return Boolean( this.accepted(course?.status_current) || this.refused(course?.status_current) || course?.deleted_at || (pp().isClient && course?.shop_id != pp().user?.shop?.id))
                return Boolean( this.accepted(course?.status_current) || this.refused(course?.status_current) || course?.deleted_at || (pp().isClient && !_.includes(pp().user?.shops_ids, course?.shop_id)))
                                    || pp().isDriver
            }
        },
        isDisabledHandleStatus(){

            return (course) => {
                // return Boolean(Number(course?.status) == 2  || Number(course?.status) == 4  || course?.signed || ! course?.count_colis || ! course.validated_at || course?.deleted_at)
                return Boolean(this.delivered(course?.status_current)  || this.refused(course?.status_current) /*  || course?.signed */ || ! course?.count_colis || ! course.validated_at || course?.deleted_at)
                        || pp().isClient//hasRole(pp().user?.roles, 'client')
            }
        },

        getValidationLabel(){

            return (course) => {
                if( ! course?.validated_at && ! course?.validate_by){ // PAS ENCORE VALIDéE OU INVALIDéE
                    return 'Non Validée'
                }
                if( ! course?.validated_at && course?.validate_by){ // INVALIDéE
                    return 'Invalidée'
                }
                if(course?.validated_at && course?.validate_by){ // VALIDéE
                    return 'Validée'
                }
            }
        },
        getValidationColor(){

            return (course) => {
                if( ! course?.validated_at && ! course?.validate_by){ // PAS ENCORE VALIDéE OU INVALIDéE
                    return 'warning'
                }
                if( ! course?.validated_at && course?.validate_by){ // INVALIDéE
                    return 'red-8'
                }
                if(course?.validated_at && course?.validate_by){ // VALIDéE
                    return 'positive'
                }
            }
        },


        getPriorityLabel(){

            // return (priority) => _.find(this.options_priority, {value: Number(priority)})?.label ?? ' - '
            return (priority) => _.find(pp().options_priority, {value: Number(priority)})?.label ?? ' - '
        },
        getPriorityColor(){

            // return (priority) => (priority < 2 ? 'grey' : (priority == 2 ? 'orange' : 'red-8'))
            return (priority) => _.find(pp().options_priority, {value: Number(priority)})?.color ?? ' - '
        },


        getStatusLabel(){

            // return (status) => pp().options_status_courses?.[status] ?? '?'
            return (status, plural = false) => {
                var s = null
                if(_.isString(status)){
                    s = _.find(pp().options_status, {skey: status})
                } else { // id status
                    s = _.find(pp().options_status, {id: status})
                }

                return s ?  s['value'+(plural ? '_plural' : '')+'_female'] : '?'
            }
        },
        getStatusPos(){

            return (status_skey) => _.find(pp().options_status, {skey: status_skey})?.pos ?? 0
        },
        getStatusColor(){
            // return (status) => {
            //     var color = 'warning'                   // personne | refusé
            //     if(status === 0){ color = 'grey' }      // pas pris en charge
            //     if(status === 1){ color = 'teal-5' }    // pris en charge
            //     if(status === 2){ color = 'positive' }  // livré
            //     return color
            // }
            return (status) => {
                var s = null
                if(_.isString(status)){
                    s = _.find(pp().options_status, {skey: status})
                } else { // id status
                    s = _.find(pp().options_status, {id: status})
                }

                return s ?  s.color : 'grey'
            }
        },
        getStatusIcon(){
            // return (status) => {
            //     var icon = 'hourglass_top'                                              // pas pris en charge
            //     if(status === 1){ icon = 'local_shipping'/* precision_manufacturing */ }// pris en charge
            //     if(status === 2){ icon = 'done_all' }                                   // livré
            //     if(status === 3){ icon = 'person_off' }                                 // personne
            //     if(status === 4){ icon = 'highlight_off' }                              // refusé
            //     return icon
            // }
            return (status) => {
                var s = null
                if(_.isString(status)){
                    s = _.find(pp().options_status, {skey: status})
                } else { // id status
                    s = _.find(pp().options_status, {id: status})
                }

                return s ?  s.icon : ''
            }
        },
    },

    actions: {


        //! for PHASE_TEST
        // resetCourse(course_id)
        // {
        //     proto.$inertia.get(route('course-reset', course_id), { preserveScroll: true })
        // },


        /**
         *
         * @param {Object} d - pagination obj
         * @param {boolean} not_with_route_params_status - optional, if true, will not take into account route().params.status (used in ButtonsTopRightIndex.vue)
         *
         * @return {Promise}
         */
        async requestList(d, not_with_route_params_status = false){

            // log('in courses action requestList()'/* ,this.filter, this.pagination */, d.pagination, route().params)

            // if( (_.size(this.filter) >= this.filter_min_length || _.size(this.filter) == 0)){			// si le filtre � mini. 2 lettres  ou ide(reset)
            // if(this.pagination != d.pagination){

            // if( ! d){ d = this }

                this.loading = true;

                if(_.size(this.filter) >= this.filter_min_length){

                    this.pagination.page = d.pagination.page = 1
                    // this.show_trashed = 0
                    // this.roles_selected = []
                }

                let params = {

                    ...(not_with_route_params_status ? {} : route().params),

                    page:           d.pagination.page,
                    sortby:         d.pagination.sortBy,
                    order:          d.pagination.descending,
                    paginate:       d.pagination.rowsPerPage,
                    filter:         this.filter,
                    // show_trashed:   this.show_trashed,
                    // roles:          this.roles_selected,
                    // status:         this.status_selected,
                }



                await proto.$inertia.get(route('course.index'),  params, {
                    onSuccess:(res)=>{
            // log('in courses action requestList() success',res)

                        this.pagination.rowsNumber  = res.props.items.total
                        this.pagination.page        = res.props.items.current_page
                        this.pagination.rowsPerPage = res.props.items.per_page
                        this.pagination.descending  = d.pagination.descending
                        this.pagination.sortBy      = d.pagination.sortBy
                    },
                    // onError:()=>{ this.loading = false }
                })

                this.loading = false;
            // }
        },

        // for Create | Update
        submit(regeneration_carrier_doc = false){

            this.form.clearErrors()

			if(regeneration_carrier_doc){
				$q.loading.show({message:"Lettre de Voiture en cours de création..."})
			} else {
                $q.loading.show()
            }

            var router = this.form.id ? route('course.update', this.form.id) : route('course.store')

            const formDatas = { ...this.form.data(), create_recipient_temp: this.form.create_recipient_temp};

            // log('in store/course submit()', router, formDatas)

            // // proto.$inertia.post(router, formDatas, { preserveScroll: true })
            proto.$inertia[this.form.id ? 'put' : 'post'](router, formDatas, {
            // this.form[this.form.id ? 'put' : 'post'](router, formDatas, {

                    preserveScroll: true,
                    onSuccess:(/* res */)=>{
                        // log('onSuccess submit Course', res)
                        this.form.reset()

						if(regeneration_carrier_doc){ $q.loading.hide() }
                    },
                    onFinish:(/* res */)=>{
                        // this.form.reset()

                        $q.loading.hide()
                    },
                    onError:(res)=>{
                        // log('onError submit Course', res)

						if(regeneration_carrier_doc){ $q.loading.hide() }

                        this.form.errors = res // ... obligatoire en utilisant  proto.$inertia ...
                        notify('warning',"Une ou plusieurs erreurs sont présentes...")

                    //     // if(res?.colis){
                    //     //     return notify('warning', 'Au moins 1 colis est requis...')
                    //     // }
                    }
             })
        },

        updateDriver(course){

            axios.post(route('course-update-driver', course.id), { driver_id: course.driver_id})
                .then((res)=>{
                    course.driver = res.data?.driver

                    notify('positive', 'Chauffeur attribué', '', 2000)
                })
        },


        // updateExpand(item/* , just_expand = false */){

        //     // var item_ = null

        //     // if(just_expand){
        //     //     item_ = { id: item.id, expand: item.expand }
        //     // } else {
        //     //     item_ = _.omit(item, ['expand'])
        //     // }

        //     proto.$inertia.put(route('course-update-expand', item.id), {expand: item.expand}, { preserveScroll: true })

        // },


        updateStatus(course, status_skey/* , colis_selected */){

            //!  /!\ au ! isProd - EN ATTENDANT DE METTRE LA FONCTIONNALITé EN LIGNE
            let setSignature =  Boolean( /*  ! isProd /!\  && */ (status_skey == 'delivered' || status_skey == 'denied') && pp().utils.custom?.signatures_courses_activated) // si LIVRé || REFUSé par le destinataire & si l'option est activée

// log('in store/course@updateStatus()',proto, isProd, setSignature, status_skey, course)

            function send(course_id, status_skey, colis_selected_and_comment__obj, signatures_obj = {})//, signature_recipient_dataURL = null)
            {
                // $q.dialog({title: 'Commentaire...', /* message: "Ajouter éventuellement un commentaire :", */
                //             cancel: true, ok: {label: 'Enregistrer', noCaps: true, color: 'positive', square: true}, persistent: true,
                //         prompt: { model: '', type: 'textarea', rows: 4, counter: true, label: 'Ajouter éventuellement un commentaire', isValid: val => val.length <= 28, hint: "Max: 240 caractères" }
                //     })
                //     .onOk((comment)=>{

                        $q.loading.show({message: setSignature ? "Signatures en cours..." : ''})

                        proto.$inertia.post(route('course-update-status', course_id), {
                                status_skey: status_skey,
                                // colis_selected: colis_selected,
                                colis_selected: colis_selected_and_comment__obj.colis_selected,
                                comment: colis_selected_and_comment__obj.comment,
                                signature_driver_dataURL: signatures_obj?.signature_driver,
                                signature_recipient_dataURL: signatures_obj?.signature_recipient,
                            }, { preserveScroll: true,
                                onSuccess:  ()=>{ $q.loading.hide() },
                                onError:    ()=>{ $q.loading.hide() }
                            })
                // })
            }

            // if((status_skey == 'delivered' || status_skey == 'refused')){

                $q.Dialog.create({
                    component: DialogComponentForUpdateStatus,
                    componentProps: {
                        course: course,
                        status_skey: status_skey,
                        setSignature: setSignature,
                    }
                })
                // .onOk(colis_selected => {
                .onOk(colis_selected_and_comment__obj => {

                    // SIGNATURES éLECTRONIQUE
                    if(setSignature){ // si LIVRé || REFUSé

                        $q.Dialog.create({
                            component: DialogComponentSignature,
                            componentProps: {
                                course: course,
                                status_skey: status_skey,
                            }
                        })
                        .onOk((signatures_obj) => {
                            send(course.id, status_skey, colis_selected_and_comment__obj, signatures_obj)
                        })
                        .onCancel(() => {
                            send(course.id, status_skey, colis_selected_and_comment__obj/* , {signature_driver: null, signature_recipient: null} */)
                        })

                    } else {
                        send(course.id, status_skey, colis_selected_and_comment__obj)
                    }

                })
            // } else {
            //     send(course.id, status_skey)
            // }

        },


        // validation(item_id){

        //     $q.dialog({title: 'Confirmation Validation...',message:`<p>Valider ou Non cette Course</p>`,html: true,
        //     // $q.dialog({title: 'Confirmation Validation...',message:`<p>Valider cette Course</p>`,html: true,
        //         ok:{label: 'Confirmer',noCaps: true,color: 'positive',outline: true, square: true}, cancel:true, persistent: true,
        //         options: { type: 'radio',  model: 1, items: [
        //             {label: 'Oui', value: 1},
        //             {label: 'Non', value: 0},
        //         ]},
        //     })
        //     .onOk((validate)=>{

        //         proto.$inertia.post(route('course-validation', item_id), {validate: validate}, { preserveScroll: true })
        //     })
        // },


        // for Edit (in Index) and Create
        initForm(action, course){
            if( ! course){ course = {} } // for Create

            if(action == 'edit' || (action == 'create' && ! _.size(this.form))){


                // this.forms[colis.id] = proto.$inertia.form({
                this.form = proto.$inertia.form({

                    id:             course.id             ?? null,
                    label:          course.label             ?? '',
                    // shop_id:            findShopIdOfClient(course.client_id),
                    shop_id:         course.shop_id         ??   findShopIdOfClient(course.client_id),
      /*HUGO BOSS*/              // client_id:      course.client_id         ?? (hasRole(pp().user?.roles, 'client') ? pp().user.id : null),
                    client_id:      course.client_id         ?? null,// Contact  //(pp().isClient ? pp().user?.id : null),

                    free_contact:   course.free_contact      ?? null,

                    // creator_id:     pp_user().id, // fait en php
                    recipient_id:   course.recipient_id      ?? null,            // destinataire
                    contact_recipient_id:   course.contact_recipient_id      ?? null,            // Contact destinataire
                    driver_id:      course.driver_id         ?? null,
                    drivered_by:    course.drivered_by       ?? null,
                    // validate_by:    course.validate_by       ?? null,
                    ref:            course.ref               ?? null,
                    priority:       course.priority          ?? 1,
                    status:         course.status            ?? 0,
                    expand:         course.expand            ?? 0,
                    // txt:            course.txt               ?? '',
                    remarks:        course.remarks               ?? '',

                    validate:                        true,                    // just for Carrier in Create
                    create_carrier_doc_in_same_time: true,

                    colis: course.colis ?? [],

                    // if user 'can_create_temp'
                    is_shop_temp:      Boolean(course.id && _.includes(_.map(pp().shops_temp,       'value'), course.shop_id)),
                    is_recipient_temp:  Boolean(course.id && _.includes(_.map(pp().recipients_temp,  'value'), course.recipient_id)),
                    shop_temp:      course.id ? _.find(pp().shops_temp,      {value: course.shop_id})       : {business_id: 1/*HUGO BOSS*/, label: '', contact: '', phone: '', address:'', temp: 1},
                    recipient_temp: course.id ? _.find(pp().recipients_temp, {value: course.recipient_id})  : {business_id: 1/*HUGO BOSS*/, label: '', contact: '', phone: '', address:'', temp: 1},
                    create_recipient_temp: false,
                })
            }
        },


        addColis(){
            this.form.clearErrors('colis')

            let new_colis = {
                course_id:      this.form?.id, // if Edit
                creator_id:     this.form?.creator_id ?? pp_user().id,
                driver_id:      this.form?.driver_id,
                recipient_id:   this.form?.recipient_id,

                user_id:        this.form?.client_id,
            }

            new_colis = colisStore().setColis(new_colis)

            this.form.colis?.push(new_colis)



            let k = (_.size(this.form.colis) - 1)

// log('in store/course addColis()',this.openModalAddColis, this.form)

            this.openModalAddColis[k] = true

            // if(this.form.id){ // veut pas fonctionner en étant ici...?!?!?
            //     this.form.create_carrier_doc_in_same_time = !this.form.create_carrier_doc_in_same_time ? true : true
            //     this.create_carrier_doc_in_same_time_disabled = true
            // }
        },


        deleteColisInForm(k, colis){

            myConfirmDialog(
                ()=> {
                    if( ! colis.id){
                        this.form.colis.splice(k, 1)
                    } else {
                        proto.$inertia.post(route('colis.forceDelete', colis.id), {forceDelete: true})
                    }

                    // if( ! this.form.colis?.length){
                    //     this.form.create_carrier_doc_in_same_time = false
                    // }
                },
                ( ! colis.id ? "Cette action n'enregistrera pas la Course." : "<p>Suppression définitive !</p><p>La course sera enregistrée automatiquement et la Lettre de voiture sera régénérée.</p>"),
                'Supprimer de la liste',
                'warning'
            )

            // $q.dialog({title: 'Confirmation Suppression...',message: "Cette action n'enregistrera pas la Course.",html: true,
            //         ok:{label: 'Supprimer de la liste',noCaps: true,color: 'warning',outline: true, square: true}, cancel:true, persistent: true,
            //     })
            //     .onOk(()=>{

            //         this.form.colis.splice(k, 1)

            //         if( ! this.form.colis?.length){
            //             this.form.create_carrier_doc_in_same_time = false
            //         }

            //         // if(this.form.id){ // veut pas fonctionner en étant ici...?!?!?
            //         //     this.form.create_carrier_doc_in_same_time = !this.form.create_carrier_doc_in_same_time ? true : true
            //         //     this.create_carrier_doc_in_same_time_disabled = true
            //         // }
            //     })
            //     // .onCancel(()=>{
            //     //     this.create_carrier_doc_in_same_time_disabled = false
            //     // })
        },


        cancelItem(item_id){

            myConfirmDialog(
                ()=> proto.$inertia.delete(route('course.destroy', item_id)+'?cancel_course=true', {}, { preserveScroll: true }),
                "<p>La Course sera définitivement supprimée.</p><p>Les colis associés le seront également.</p>",
                'Ok',
                'warning'
            )

            // $q.dialog({title: 'Confirmation d\'Annulation...',message: "<p>La Course sera définitivement supprimée.</p><p>Les colis associés le seront également.</p>",html: true,
            //     ok:{label: 'Ok',noCaps: true,color: 'warning',outline: true, square: true}, cancel:true, persistent: true,
            // })
            // .onOk(()=>{
            //     proto.$inertia.delete(route('course.destroy', item_id), {}, { preserveScroll: true })
            // })
        },

        groupedArchivage(){

            $q.dialog({title: "Archivage Groupé...", message: "<p>Cette action archivera automatiquement et <b>définitivement</b> toutes les courses terminées depuis le nombre de jours que vous choisirez ci-dessous :</p>",html: true,
                ok:{label: 'Archiver',noCaps: true,color: 'positive',outline: true, square: true}, cancel:true, persistent: true,
                options: { type: 'radio',  model: 15, items: [
                    {label: '10 jours', value: 10},
                    {label: '15 jours', value: 15},
                    {label: '20 jours', value: 20},
                    {label: '25 jours', value: 25},
                    {label: '30 jours', value: 30},
                    {label: '45 jours', value: 45},
                    {label: '60 jours', value: 60},
                ]},
            })
            .onOk((nb_days)=>{
                proto.$inertia.post(route('course-grouped-archivage'), {nb_days: nb_days}, { preserveScroll: true })
            })
        },


       /*  recapMonthly(){

            let date_now  = dateNow('YYYY-MM')
            let year  = Number(dateNow('YYYY'))
            let month = Number(dateNow('MM'))

            let years = [ {label: year, value: year} ]
            for(var y = (year - 1); y >= (year - 3); y--){
                years.unshift( {label: y, value: y})
            }

            let months = []

            // log('in recapMonthly()', year, years, month, months)

            $q.dialog({title: "Choisissez l'année voulue", //message: "",html: true,
                ok:{label: 'Continuer',noCaps: true,color: 'positive',outline: true, square: true}, cancel:true, persistent: true,
                options: { type: 'radio', dense: true, model: year, items: years},
            })
            .onOk((year_selected)=>{

                for(var m = 1; m <= 12; m++){
                    var m_str = (m < 10 ? '0'+m : m)
                    months.push({label: m_str+'/'+year_selected, value: Number(m_str)})
                }

                $q.dialog({title: "Choisissez le mois voulu en "+year_selected, //message: "",html: true,
                    ok:{label: 'Récap. Mensuelle',noCaps: true,color: 'positive',outline: true, square: true}, cancel:true, persistent: true,
                    options: { type: 'radio', dense: true, model: month, items: months},
                })
                .onOk((month_selected)=>{

                    var month_selected_str = (month_selected < 10 ? '0'+month_selected : month_selected)

                    if(date_now < year_selected+'-'+month_selected){
                        notify('warning', "Cette date n'est pas valide...", month_selected_str+'/'+year_selected)
                        return this.recapMonthly()
                    }

                    axios.post(route('course-recap-monthly'), {year: year_selected, month: month_selected_str})
                        .then((res)=>{
                            // log('in OK recapMonthly()', res)

                            this.recapMonthlyResult = res.data ?? []

                            this.recapMonthlyOpenModal = true
                        })
                        .catch((err)=>{
                            // log('in ERROR recapMonthly()', err)
                            if(err.status == 403){
                                return notify('warning', "Vous n'avez pas les droits nécessaires...")
                            }
                        })
                })
            })
        }, */


        async exportCoursesXLS()
        {

            let courses_selected = this.recapMonthlyResult?.selected

            let courses_ids = []

            _.each(courses_selected, (v, c_id)=>{
                if(v){
                    courses_ids.push(c_id)
                }
            })
            // log(courses_selected, courses_ids)

            if(courses_ids.length)
            {

                $q.loading.show({message: 'Fichier en cours de création...'})

                await axios.post(route('course-export-xls'),
                        {   courses_ids: courses_ids,
                            period: this.recapMonthlyResult?.period
                        },{ responseType: 'blob' })
                            .then((res)=>{

                                if( !res?.data)
                                {
                                    return notify('warning', "Ooops... L'exportation n'as pas abouti.",'',6000)
                                }

                                downloadFile(res, "Recapitulatif-Courses_Periode-"+this.recapMonthlyResult?.period+".xlsx"); // in link helper
                            })
                            .catch((error)=>{
                                // log('ERROR in stores/course/exportCoursesXLS()', error)
                                notify('warning', "L'exportation n'as pas abouti...")
                            })

                $q.loading.hide()

            } else {
                notify('warning', "Aucune course sélectionnée...")
            }


        },

        exportCourseXLS(course_id){

            axios.get(route('course.export', course_id), { responseType: 'blob' })
                .then((res)=>{
                    // log('in OK exportCourseXLS()', res)
                    if( ! res?.data){
                        return notify('warning', "Ooops... L'exportation n'as pas abouti.",'',6000)
                    }

                    downloadFile(res)
                })
                .catch((error)=>{
                    // log('ERROR in stores/course/exportCourseXLS()', error)
                    notify('warning', "L'exportation n'as pas abouti...")
                })

        },


        // for add Recipient
        // addRecipient(/* business_id */){
        //     // if(business_id){

        //         this.showRecipientAddForm = true

        //         this.formAddRecipient = proto.$inertia.form({
        //             label: '',
        //             business_id: null,//business_id,
        //             description: '',
        //             contact: '',
        //             email: '',
        //             phone: '',
        //             address: '',
        //             latitude: null,
        //             longitude: null,
        //         })
        //     // }
        // },

        // submitAddRecipient(){

        //     this.formAddRecipient.post(route('add-recipient'),{
        //         preserveScroll: true,
        //         onSuccess:(res)=>{

        //             this.showRecipientAddForm = false

        //             this.form.recipient_id = res.props.result

        //             this.formAddRecipient.reset()
        //         }
        //     })
        // },


    }
}
